import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

export const ErxBonusLandingPageHowBonusIsCalculatedInfoStepsV1: FC = () => {
  return (
    <div className="flex w-full items-center justify-between gap-4">
      <span className="rounded-full bg-light-tertiary px-4 py-1 text-m font-medium tablet:text-l">
        <FormattedMessage id="deErx.bonus.howBonusIsCalculated.example.item.bonus" />
      </span>
      <div className="flex flex-col">
        <span className="font-medium">
          <FormattedMessage id="deErx.bonus.howBonusIsCalculated.example.item.copayment.title" />
        </span>
        <span className="text-xl font-medium">
          <FormattedMessage id="deErx.bonus.howBonusIsCalculated.example.item.copayment.amount" />
        </span>
      </div>
    </div>
  )
}
